import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { translations } from '@/data/translations';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 md:px-12 lg:px-24" data-testid="not-found-page">
      <div className="text-center">
        <h1 className="font-serif text-8xl md:text-9xl text-[#E5E5E5] mb-4">
          404
        </h1>
        <h2 className="font-serif text-3xl md:text-4xl text-[#2C2C2C] tracking-tight mb-4">
          {t(translations.notFound.title)}
        </h2>
        <p className="font-sans text-lg text-[#5D5D5D] max-w-md mx-auto mb-8">
          {t(translations.notFound.message)}
        </p>
        <Button 
          asChild
          className="rounded-full bg-[#2C2C2C] text-white px-8 py-4 h-auto hover:bg-[#4A5D4F] transition-colors duration-300 text-sm uppercase tracking-widest"
        >
          <Link to="/" data-testid="back-home-btn">
            <ArrowLeft className="mr-2 h-4 w-4" strokeWidth={1.5} />
            {t(translations.notFound.backHome)}
          </Link>
        </Button>
      </div>
    </div>
  );
}
